export default __webpack_public_path__ + "static/media/Check_transparent.aa9223a9.svg";